import React from "react";

export type Image = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
interface ConfigurableImageProps extends Image {
  overrides?: Image;
}

export const ConfigurableImage = ({ overrides, ...props }: ConfigurableImageProps) => {
  const imageProps = {
    ...props,
    ...(overrides || {}),
  };

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...imageProps} />;
};
